#import "../../../../master-dashboard/dash-grid/cards/graphql/fragments/cta-banner-fragment.graphql"

query GetIntroWebcastBanner {
    introWebcastBanner {
        ...CTABanner
    }
}
